module.exports = __webpack_public_path__ + "static/media/ext17.ed1b46c7.jpg";